import React, { useState } from "react";
import axios from "axios";
import { Constant } from "../helper/Constants";
import Header from "./Header";
import Footer from "./Footer";
import FaqEvent from "./FaqEvent";

import boyAbacus from "../images/boyAbacus.jpg";
import teacher from "../images/teacher.png";
import school from "../images/thumb-up.png";
import library from "../images/bookshelf.png";

const AbacusOnlineClasses = () => {
  const [form, setForm] = useState({
    studentName: "",
    guardianName: "",
    email: "",
    whatsapp: "",
    city: "",
    ageGroup: "6 to 12 Years old",
    classDate: "",
  });
   const [allYoutube, setAllYoutube] = useState([]);
  const [homeYoutube, setHomeYoutube] = useState({});
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const validate = () => {
    if (!form.studentName.trim()) {
      setStatusMsg({ text: "Please enter student name.", type: "error" });
      return false;
    }
    if (!form.whatsapp.trim()) {
      setStatusMsg({ text: "Please enter WhatsApp number.", type: "error" });
      return false;
    }
    return true;
  };



  const allVideos = async () => {
    try {
      const resp = await axios.get(Constant.getUrls.getAllYoutTubeSlider);
      setAllYoutube(resp?.data?.data);

      const response = await axios.get(Constant.getUrls.getAllYoutube);
      setHomeYoutube(response?.data?.data);
    } catch (error) {
      console.log(error);
      setAllYoutube([]); // fallback handled in render
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setStatusMsg({ text: "Submitting...", type: "info" });

    try {
      const payload = {
        student_name: form.studentName,
        guardian_name: form.guardianName,
        email: form.email,
        contact: form.whatsapp,
        city: form.city,
        age: form.ageGroup,
        date: form.classDate,
      };

      const resp = await axios.post(
        Constant?.postUrls?.createDemo || "/api/demo-request",
        payload
      );

      setStatusMsg({
        text: resp?.data?.message || "Demo booked successfully!",
        type: "success",
      });

      setForm({
        studentName: "",
        guardianName: "",
        email: "",
        whatsapp: "",
        city: "",
        ageGroup: "6 to 12 Years old",
        classDate: "",
      });
    } catch (err) {
      setStatusMsg({
        text: "Something went wrong. Try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px",
    borderRadius: 8,
    border: "1px solid #ddd",
    marginBottom: 12,
  };

  return (
    <>
      <Header />

      <div style={{ fontFamily: "Poppins, sans-serif", overflowX: "hidden" }}>
        {/* ================= HERO SECTION ================= */}
        <section
          style={{
            padding: "40px 16px",
            maxWidth: 1200,
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            gap: 40,
          }}
        >
          {/* LEFT */}
          <div style={{ flex: "1 1 420px" }}>
            <h1 style={{ color: "#ff6f6f", fontSize: 36 }}>
              LEARN ABACUS
            </h1>
            <h2 style={{ fontSize: 22 }}>
              Boost Mental Math Skills <br /> Spark Early Math Genius
            </h2>

            <div
              style={{
                marginTop: 20,
                borderRadius: 16,
                overflow: "hidden",
                boxShadow: "0 8px 20px rgba(0,0,0,.15)",
              }}
            >
              <img
                src={boyAbacus}
                alt="Abacus"
                style={{ width: "100%", height: 300, objectFit: "cover" }}
              />
            </div>
          </div>

          {/* FORM */}
          <form
            onSubmit={handleSubmit}
            style={{
              flex: "1 1 360px",
              background: "#fff",
              padding: 24,
              borderRadius: 20,
              boxShadow: "0 10px 25px rgba(0,0,0,.1)",
            }}
          >
            <h2 style={{ textAlign: "center" }}>Book Free Demo</h2>

            <input
              name="studentName"
              placeholder="Student Name"
              value={form.studentName}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              name="guardianName"
              placeholder="Guardian Name"
              value={form.guardianName}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              name="whatsapp"
              placeholder="WhatsApp Number"
              value={form.whatsapp}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              name="city"
              placeholder="City"
              value={form.city}
              onChange={handleChange}
              style={inputStyle}
            />

            <select
              name="ageGroup"
              value={form.ageGroup}
              onChange={handleChange}
              style={inputStyle}
            >
              <option>6 to 12 Years old</option>
              <option>3 to 5 Years old</option>
              <option>13+ Years old</option>
            </select>

            <input
              type="date"
              name="classDate"
              value={form.classDate}
              onChange={handleChange}
              style={inputStyle}
            />

            {statusMsg.text && (
              <p
                style={{
                  textAlign: "center",
                  color:
                    statusMsg.type === "success"
                      ? "green"
                      : statusMsg.type === "error"
                      ? "red"
                      : "#555",
                }}
              >
                {statusMsg.text}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: 14,
                background: "#ff6f6f",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              {loading ? "Booking..." : "Book Now"}
            </button>
          </form>
        </section>

        {/* ================= VIDEO SECTION ================= */}
        <section style={{ padding: "40px 16px", textAlign: "center" }}>
          <h2>How Our Online Abacus Classes Work</h2>
          <div
            style={{
              maxWidth: 900,
              margin: "20px auto",
              borderRadius: 16,
              overflow: "hidden",
            }}
          >
            <iframe
              width="100%"
              height="400"
              src={"https://www.youtube.com/embed/" + homeYoutube?.franchise_youtube_1}
              allowFullScreen
              style={{ border: "none" }}
            />
          </div>
        </section>

      {/* ================= BENEFITS ================= */}
<section
  style={{
    padding: "40px 16px",
    maxWidth: 1200,
    margin: "0 auto",
  }}
>
  <h2 style={{ textAlign: "center" }}>
    Benefits of <span style={{ color: "#ff6f6f" }}>Abacus</span>
  </h2>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: 30,
      marginTop: 30,
      alignItems: "center",
    }}
  >
    {/* ===== LEFT BENEFITS LIST ===== */}
    <div
      style={{
        flex: "1 1 320px",
        maxWidth: 500,
      }}
    >
      {[
        "Self-Confidence",
        "Concentration",
        "Photographic Memory",
        "Ability To Recall",
        "Visualization",
        "Listening Skill",
      ].map((b, i) => (
        <div
          key={i}
          style={{
            background: [
              "#E65100",
              "#43A047",
              "#FBC02D",
              "#1E88E5",
              "#E53935",
              "#43A047",
            ][i],
            padding: "12px 16px",
            marginBottom: 12,
            borderRadius: 6,
            color: "white",
            fontWeight: 600,
            width: "100%",
            textAlign: "center",
          }}
        >
          {b}
        </div>
      ))}
    </div>

    {/* ===== RIGHT VIDEO ===== */}
    <div
      style={{
        flex: "1 1 320px",
        width: "100%",
      }}
    >
      <iframe
        width="100%"
        height="280"
        src={"https://www.youtube.com/embed/" + homeYoutube?.franchise_youtube_2}
        style={{
          borderRadius: 12,
          border: "none",
          width: "100%",
        }}
        allowFullScreen
      />
    </div>
  </div>
</section>


        {/* ================= WHY BEST ================= */}
        <section
          style={{
            padding: "40px 16px",
            background: "#FDEFE6",
            marginTop: 40,
          }}
        >
          <h2 style={{ textAlign: "center" }}>
            Why We're The <span style={{ color: "#ff6f6f" }}>Best</span>
          </h2>

          <div
            style={{
              maxWidth: 1000,
              margin: "30px auto",
              display: "flex",
              flexWrap: "wrap",
              gap: 30,
            }}
          >
            {[
              { img: teacher, title: "Global Leaders" },
              { img: school, title: "100,000+ Students" },
              { img: library, title: "Gamified Learning" },
            ].map((i, idx) => (
              <div
                key={idx}
                style={{
                  flex: "1 1 260px",
                  background: "#fff",
                  padding: 20,
                  borderRadius: 16,
                  textAlign: "center",
                }}
              >
                <img src={i.img} alt="" style={{ width: 60 }} />
                <h4>{i.title}</h4>
              </div>
            ))}
          </div>
        </section>

        {/* ================= FAQ ================= */}
        <section style={{ padding: "40px 16px" }}>
          <FaqEvent />
        </section>
      </div>

      <Footer />
    </>
  );
};

export default AbacusOnlineClasses;


// import React, { useState } from "react";

// import axios from "axios";
// import { Constant } from "../helper/Constants";
// import Header from "./Header";
// import abacus from "../images/abacus.jpg"
// import boyAbacus from "../images/boyAbacus.jpg";
// import teacher from "../images/teacher.png";
// import school from "../images/thumb-up.png";
// import library from "../images/bookshelf.png";
// import FaqEvent from "./FaqEvent";
// import Footer from "./Footer";

// const AbacusOnlineClasses = () => {
//   // ------------------ FORM STATE -------------------
//   const [form, setForm] = useState({
//     studentName: "",
//     guardianName: "",
//     email: "",
//     whatsapp: "",
//     city: "",
//     ageGroup: "6 to 12 Years old",
//     classDate: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [statusMsg, setStatusMsg] = useState({ text: "", type: "" });

//   // ------------------ FORM HANDLERS -------------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const validate = () => {
//     if (!form.studentName.trim()) {
//       setStatusMsg({ text: "Please enter student name.", type: "error" });
//       return false;
//     }
//     if (!form.whatsapp.trim()) {
//       setStatusMsg({ text: "Please enter WhatsApp number.", type: "error" });
//       return false;
//     }
//     if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
//       setStatusMsg({
//         text: "Please enter a valid email address.",
//         type: "error",
//       });
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setLoading(true);
//     setStatusMsg({ text: "Submitting...", type: "info" });

//     try {
//       const payload = {
//         student_name: form.studentName,
//         guardian_name: form.guardianName,
//         email: form.email,
//         contact: form.whatsapp,
//         city: form.city,
//         age: form.ageGroup,
//         date: form.classDate,
//       };

//       const endpoint = Constant?.postUrls?.createDemo || "/api/demo-request";

//       const resp = await axios.post(endpoint, payload);

//       if (resp?.data?.status === "success" || resp?.status === 200) {
//         setStatusMsg({
//           text: resp?.data?.message || "Demo booking submitted!",
//           type: "success",
//         });

//         setTimeout(() => {
//           setForm({
//             studentName: "",
//             guardianName: "",
//             email: "",
//             whatsapp: "",
//             city: "",
//             ageGroup: "6 to 12 Years old",
//             classDate: "",
//           });
//           setStatusMsg({ text: "", type: "" });
//         }, 800);
//       } else {
//         setStatusMsg({
//           text: resp?.data?.message || "Failed. Please try again later.",
//           type: "error",
//         });
//       }
//     } catch (err) {
//       setStatusMsg({
//         text:
//           err?.response?.data?.message ||
//           err?.message ||
//           "Booking failed. Please try again.",
//         type: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ------------------ INLINE STYLES -------------------
//   const inputStyle = {
//     borderRadius: 10,
//     padding: "12px 14px",
//     fontSize: 14,
//     border: "1px solid #ddd",
//     background: "#fbfbfb",
//     height: 44,
//     width: "100%",
//     marginBottom: 12,
//   };

//   const selectStyle = {
//     ...inputStyle,
//     appearance: "none",
//     WebkitAppearance: "none",
//     backgroundImage:
//       "url(\"data:image/svg+xml;utf8,<svg fill='black' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
//     backgroundRepeat: "no-repeat",
//     backgroundPosition: "right 14px center",
//   };

//   const pageWidth = {
//     width: "80%",
//     margin: "0 auto",
//   };

//   return (
//     <>
//       <Header />

//       <div style={{ fontFamily: "'Poppins', sans-serif" }}>
//         {/* -------------------------------------------------------------------------
//           SECTION 1: HERO + EMBEDDED FORM
//         -------------------------------------------------------------------------- */}
//         <section
//           style={{
//             padding: "60px 0",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             flexWrap: "wrap",
//             gap: "80px",
//             ...pageWidth,
//           }}
//         >
//           {/* LEFT TEXT + VIDEO */}
//           <div>
//             <h1 style={{ fontSize: 40, fontWeight: 800, color: "#ff6f6f" }}>
//               LEARN ABACUS
//             </h1>

//             <h2 style={{ fontSize: 22, fontWeight: 600 }}>
//               Boost Mental Math Skills
//               <br /> SPARK EARLY MATH GENIUS
//             </h2>

//             {/* VIDEO */}
//             <div
//               style={{
//                 width: "100%",
//                 height: "360px",
//                 marginTop: 20,
//                 borderRadius: 15,
//                 overflow: "hidden",
//                 boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//               }}
//             >
//               <img
//                 // src="../../images/boyAbacus.jpg"
//                 src={boyAbacus}
//                 alt="Abacus Video Placeholder"
//                 style={{
//                   //   width: "100%",
//                   height: "360px",
//                   objectFit: "cover",
//                 }}
//               />
              
//             </div>
//           </div>

//           {/* EMBEDDED FORM (FULL MODAL UI) */}
//           <form
//             onSubmit={handleSubmit}
//             style={{
//               width: "100%",
//               maxWidth: 520,
//               background: "#fff",
//               padding: 30,
//               borderRadius: 20,
//               boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
//             }}
//           >
//             <h3 style={{ textAlign: "center" }}>Abacus Live Classes</h3>
//             <h2 style={{ textAlign: "center", marginBottom: 20 }}>
//               Book A Free Demo Class
//             </h2>

//             <label>Student Name</label>
//             <input
//               name="studentName"
//               placeholder="Enter Student Name"
//               value={form.studentName}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <label>Guardian Name</label>
//             <input
//               name="guardianName"
//               placeholder="Enter Guardian Name"
//               value={form.guardianName}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <label>Email (optional)</label>
//             <input
//               type="email"
//               name="email"
//               placeholder="Enter Email"
//               value={form.email}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <label>WhatsApp Number</label>
//             <input
//               name="whatsapp"
//               placeholder="Enter WhatsApp Number"
//               value={form.whatsapp}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <label>City</label>
//             <input
//               name="city"
//               placeholder="Enter Your City"
//               value={form.city}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <label>Age Group</label>
//             <select
//               name="ageGroup"
//               value={form.ageGroup}
//               onChange={handleChange}
//               style={selectStyle}
//             >
//               <option value="6 to 12 Years old">6 to 12 Years old</option>
//               <option value="3 to 5 Years old">3 to 5 Years old</option>
//               <option value="13+ Years old">13+ Years old</option>
//             </select>

//             <label>Preferred Date</label>
//             <input
//               type="date"
//               name="classDate"
//               value={form.classDate}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             {/* STATUS MESSAGE */}
//             {statusMsg.text && (
//               <p
//                 style={{
//                   marginTop: 10,
//                   color:
//                     statusMsg.type === "success"
//                       ? "green"
//                       : statusMsg.type === "error"
//                       ? "red"
//                       : "#555",
//                   textAlign: "center",
//                 }}
//               >
//                 {statusMsg.text}
//               </p>
//             )}

//             <button
//               type="submit"
//               disabled={loading}
//               style={{
//                 width: "100%",
//                 marginTop: 10,
//                 padding: "12px 16px",
//                 borderRadius: 10,
//                 background: "#ff6f6f",
//                 color: "#fff",
//                 border: "none",
//                 fontSize: 16,
//                 cursor: "pointer",
//               }}
//             >
//               {loading ? "Booking..." : "Book Now"}
//             </button>

//             <p style={{ fontSize: 12, marginTop: 10 }}>
//               By registering, you agree to our Terms & Conditions and Privacy
//               Policy.
//             </p>
//           </form>
//         </section>

//         {/* -------------------------------------------------------------------------
//           SECTION 2: VIDEO DEMO
//         -------------------------------------------------------------------------- */}
//         <section
//           style={{ padding: "60px 20px", textAlign: "center", ...pageWidth }}
//         >
//           <h1 style={{ fontSize: 32, fontWeight: 800 }}>
//             Transform Your Child’s Math Abilities with{" "}
//             <span style={{ color: "#ff6f6f" }}>Our Abacus Online Classes!</span>
//           </h1>

//           <p style={{ maxWidth: 700, margin: "10px auto" }}>
//             Watch this video and discover how our Abacus online classes work
//             using fun visual tools.
//           </p>

//           <div
//             style={{
//               marginTop: 40,
//               borderRadius: 20,
//               overflow: "hidden",
//               boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//             }}
//           >
//             <iframe
//               width="100%"
//               height="400"
//               src="https://www.youtube.com/embed/MgH-nFpUYvY"
//               allowFullScreen
//               style={{ border: "none" }}
//             ></iframe>
//           </div>
//         </section>

//         {/* -------------------------------------------------------------------------
//           SECTION 3: BENEFITS
//         -------------------------------------------------------------------------- */}
//         <section style={{ padding: "60px 20px", ...pageWidth }}>
//           <h1 style={{ textAlign: "center", fontSize: 32, fontWeight: 800 }}>
//             BENEFITS OF <span style={{ color: "#ff6f6f" }}>ABACUS</span>
//           </h1>

//           <p
//             style={{ textAlign: "center", maxWidth: 700, margin: "10px auto" }}
//           >
//             VASA-Abacus Abacus training develops dynamic number sense in
//             children.
//           </p>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-around",
//               flexWrap: "wrap",
//               gap: 40,
//             }}
//           >
//             <div>
//               {[
//                 "Self-Confidence",
//                 "Concentration",
//                 "Photographic Memory",
//                 "Ability To Recall",
//                 "Visualization",
//                 "Listening Skill",
//               ].map((b, i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: [
//                       "#E65100",
//                       "#43A047",
//                       "#FBC02D",
//                       "#1E88E5",
//                       "#E53935",
//                       "#43A047",
//                     ][i],
//                     padding: "12px",
//                     marginBottom: 10,
//                     marginTop: 20,
//                     borderRadius: 4,
//                     color: "white",
//                     fontWeight: 600,
//                     width: "200%",
//                   }}
//                 >
//                   {b}
//                 </div>
//               ))}
//             </div>

//             {/* VIDEO */}
//              <div
//               style={{
//                 width: "50%",
//                 height: "330px",
//                 marginTop: 20,
//                 borderRadius: 15,
//                 overflow: "hidden",
//                 boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//               }}
//             >
//               <iframe
//                 src="https://www.youtube.com/embed/6POCMCMhSgI"
//                 width="100%"
//                 height="100%"
//                 style={{ border: "none" }}
//                 allowFullScreen
//               ></iframe>
              
//             </div>
//           </div>
//         </section>

//         {/* -------------------------------------------------------------------------
//           SECTION 4: BEST IN GAME
//         -------------------------------------------------------------------------- */}
//         <section style={{ padding: "60px 20px", ...pageWidth }}>
//           <h1 style={{ textAlign: "center", fontSize: 32, fontWeight: 800 }}>
//             Why We're The{" "}
//             <span style={{ color: "#ff6f6f" }}>Best In The Game?</span>
//           </h1>

//           <p style={{ textAlign: "center", color: "#555" }}>
//             Live Classes. Interactive Games.
//           </p>

//           <div
//             style={{
//               marginTop: 40,
//               background: "#FDEFE6",
//               borderRadius: 25,
//               padding: 40,
//               display: "flex",
//               justifyContent: "center",
//               flexWrap: "wrap",
//               gap: 40,
//             }}
//           >
//             {/* LEFT VIDEO */}
//             <div>
//               <iframe
//                 width="550"
//                 height="350"
//                 src="https://www.youtube.com/embed/6POCMCMhSgI"
//                 style={{
//                   border: "none",
//                   borderRadius: 20,
//                   boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//                 }}
//                 allowFullScreen
//               ></iframe>
//               <p
//                 style={{ textAlign: "center", marginTop: 10, fontWeight: 600 }}
//               >
//                 You won't ever fear numbers!
//               </p>
//             </div>

//             {/* RIGHT FEATURE LIST */}
//             <div style={{ maxWidth: 420 }}>
//               {[
//                 {
//                   title: "GLOBAL LEADERS",
//                   desc: "Global Leaders in Abacus Education (Since 2005)",
//                   image: teacher
//                 },
//                 {
//                   title: "MATH WHIZZES",
//                   desc: "100,000+ Math Whizzes Made",
//                   image: school,
//                 },
//                 {
//                   title: "The Future of Learning",
//                   desc: "Gamified Abacus Portal for Smart Learning",
//                   image: library,
//                 },
//               ].map((item, idx) => (
//                 <div
//                   key={idx}
//                   style={{ display: "flex", gap: 15, marginBottom: 20 }}
//                 >
//                   <img
//                     src={item?.image}
//                     alt=""
//                     style={{ width: 60, height: 60 }}
//                   />
//                   <div>
//                     <h3 style={{ margin: 0 }}>{item.title}</h3>
//                     <p style={{ margin: 0, color: "#555" }}>{item.desc}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* -------------------------------------------------------------------------
//           FAQ
//         -------------------------------------------------------------------------- */}
//         <section style={{ padding: "60px 20px", ...pageWidth }}>
//             <FaqEvent/>
//         </section>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default AbacusOnlineClasses;
